<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead> -->
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-input clearable v-model="queryData.name" size="small" style="width:210px" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['accountManage:userManage:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['accountManage:userManage:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="tableTopBtn space_between">
					<el-button type="primary" size="small" @click="addTableData" v-hasPermi="['accountManage:userManage:add']">
						<i class="el-icon-plus"></i> 新增
					</el-button>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table">
					<el-table-column prop="createdTime" label="创建时间"></el-table-column>
					<el-table-column prop="roleName" label="用户角色">
						<template slot-scope="scope">
							<div v-if="scope.row.roleName&&scope.row.roleName.length>0">{{scope.row.roleName.join(',')}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="userName" label="用户账号"></el-table-column>
					<el-table-column prop="passWord" label="用户密码">******</el-table-column>
					<el-table-column prop="phone" label="手机号"></el-table-column>
					<el-table-column prop="" label="状态">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" @change="userSwitchChange($event,scope.row)"
							:active-value="1" :inactive-value="0"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作" fixed="right" width="150">
						<template slot-scope="scope">
							<el-button type="text" @click="editTable(scope.row,scope.$index)"
							v-hasPermi="['accountManage:userManage:edit']">编辑</el-button>
							<el-button type="text" v-hasPermi="['accountManage:userManage:delete']" @click="deleteTable(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="用户管理" :visible.sync="dialogVisible" width="48%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="appRulesApi" :model="appFormData"
				ref="ruleAPPForm">
				<el-form-item label="用户账号：" prop="userName">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.userName"></el-input>
				</el-form-item>
				<el-form-item label="用户密码：" prop="passWord">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.passWord"></el-input>
				</el-form-item>
				<el-form-item label="用户角色：" required>
					<el-select v-model="appFormData.roleIds" clearable size="small" multiple>
						<el-option v-for="item in roleOptions" :key="item.roleId" :label="item.roleName" :value="item.roleId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="手机号码：" prop="phone">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.phone"></el-input>
				</el-form-item>
				<el-form-item label="邮件地址：" prop="email">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.email"></el-input>
				</el-form-item>
				<el-form-item label="配置公司：" prop="email">
					<!-- :check-strictly="true" @check="checkChange" -->
					<!-- :default-checked-keys="menusChecked" -->
					<!-- @check="treeCheckFun" -->
					<!-- <div class="el_tree">
						<el-tree :data="treeData" show-checkbox node-key="id" default-expand-all :props="defaultProps"
							ref="menuTreeRef" @node-expand="nodeExpend">
							<template slot-scope="{ node, data }">
								<div class="custom-tree-node" :class="{
										'level1-node': node.level === 1,
										'level2-node': node.level === 2,
										'level3-node': node.level === 3,
									}">
									<div>{{ node.label }}</div>
								</div>
							</template>
						</el-tree>
					</div> -->
					<div class="el_tree">
						<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
						>全选</el-checkbox>
						<el-checkbox-group v-model="configChecked" class="tHeadFixedCheckList">
							<el-checkbox v-for="(item,index) in treeData" :label="item.id" size="mini"
								:checked="item.checked" :key="index" :name="item.name" class="check-box-fixed"
								@change="checkBoxQueryChange($event,item,index)">{{item.name}}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeAPPDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmAPP('ruleAPPForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="重置密码" :visible.sync="dialogVisiblePwd" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="pwdRulesApi" :model="pwdFormData"
				ref="rulePwdForm">
				<el-form-item label="密码：" prop="passWord">
					<el-input clearable size="small" placeholder="请输入" v-model="pwdFormData.passWord"></el-input>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closePwdDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmPwd('rulePwdForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import { log } from 'console';
	export default {
		data() {
			return {
				mainHeadTitle: '账户管理',
				hasPermiDict: 'userManage:userManage:add',
				datePicker: [],
				appSelectData: [], // APP下拉选择列表
				queryData: {},
				pwdFormData: {},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				appRulesApi: {
					userName: [{required: true,message: '请输入用户名',trigger: 'blur'}],
					passWord: [{required: true,message: '请输入密码',trigger: 'blur'}],
				},
				pwdRulesApi: {
					passWord: [{required: true,message: '请输入密码',trigger: 'blur'}],
				},
				appFormData: {
					isList: 1,
					roleIds: []
				},

				dialogVisible: false, // 弹框显隐
				dialogVisiblePwd: false,
				roleOptions: [],
				
				
				treeData: [],
				isTreeCheck: false,
				defaultProps: {
					children: 'app',
					label: 'name'
				},
				
				configChecked: [],
				dimensionCheckAll: false,
				isDimensionIndeterminate: false,
			}
		},
		mounted() {
			this.getRoleSelectOptions();
			this.getTableData();
			this.getMenuList();
		},
		methods: {
			checkBoxQueryChange(e, item, index) {
				this.treeData[index].checked = e
				this.dimensionCheckAll = this.configChecked.length === this.treeData.length
				this.isDimensionIndeterminate = this.configChecked.length > 0 &&  this.configChecked.length < this.treeData.length
			},
			handleCheckAllChangeDim(val){
				this.configChecked = []
				if(val){
					this.treeData.forEach((item) => {
						this.configChecked.push(item.id)
					})
				}
				this.isDimensionIndeterminate = false;
			},
			nodeExpend(){
				this.$nextTick(()=>{
					setTimeout(()=>{
						this.updateTreeStyles();
					},50)
				})
			},
			// 修改el-tree子集背景颜色及布局
			updateTreeStyles() {
				const level2Nodes = document.getElementsByClassName('level2-node');
				Array.from(level2Nodes).forEach(node => {
					const parentContent = node.closest('.el-tree-node__content');
					if (parentContent) {
						parentContent.style.background = '#F9F9FB';
						// 获取父级.el-tree-node__content的兄弟元素.el-tree-node__children
						const parentNode = parentContent.parentElement;
						const siblingChildren = parentNode.querySelector(':scope > .el-tree-node__children');
						// 判断还有没有子集，没有做出相应处理
						if (siblingChildren) {
							if(window.getComputedStyle(siblingChildren).height == '0px'){
								// 拿到level2-node的祖先元素
								let flexNode = parentNode.parentElement
								// console.log(flexNode);
								parentNode.style.background = '#FFFFFF';
								parentContent.style.background = '#FFFFFF';
								flexNode.style.background = '#FFFFFF';
								flexNode.style.display = 'flex';
								flexNode.style.flexWrap = 'wrap';
							}
						}
					}
				});
				// 修改level3-node的样式保持不变
				const level3Nodes = document.getElementsByClassName('level3-node');
				Array.from(level3Nodes).forEach(node => {
					const parentContent = node.closest('.el-tree-node__content');
					if (parentContent) {
						parentContent.style.background = '#FFFFFF';
					}
				});
			},
			// 获取菜单列表
			async getMenuList() {
				let res = await this.$http.post(this.$api.userManage.appListOptions);
				if (res.code == 1) {
					for(let i=0;i<res.data.length;i++){
						res.data[i]['level'] = 1
						res.data[i]['checked'] = false
						if(res.data[i].app&&res.data[i].app.length>0){
							for(let j=0;j<res.data[i].app.length;j++){
								res.data[i].app[j]['level'] = 2
							}
						}
					}
					this.treeData = res.data
					// console.log(this.treeData)
				}
			},
			// 获取菜单节点选中数据
			getMenuAllCheckedKeys() {
				// 目前被选中的菜单节点
				let checkedKeys = this.$refs.menuTreeRef.getCheckedKeys(true);
				// 半选中的菜单节点
				// let halfCheckedKeys = this.$refs.menuTreeRef.getHalfCheckedKeys();
				checkedKeys.unshift.apply(checkedKeys);
				return checkedKeys;
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				data = {...data,...this.queryData}
				let res = await this.$http.get(this.$api.adminUserEdit, data);
				this.tableData = res.data.records
				this.total = res.data.total
			},
			// 获取角色下拉选择列表
			async getRoleSelectOptions(){
				let res = await this.$http.get(this.$api.userManage.roleSelectOptions);
				if(res.code==1){
					this.roleOptions = res.data
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			// 新增表格信息
			addTableData() {
				this.appFormData = {
					isList: 1,
					roleIds: []
				},
				// this.$refs.menuTreeRef.setCheckedKeys([]);
				this.configChecked = []
				this.isAdEditDialog = false
				this.dialogVisible = true
				this.dimensionCheckAll = false
				this.isDimensionIndeterminate = false
			},
			// 用户删除
			deleteTable(item,index){
				this.$confirm('此操作将删除该条用户信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = {
						idList: [item.id]
					};
					let res = await this.$http.post(this.$api.userManage.userDelete, data);
					if (res.code == 1) {
						this.$message.success('删除成功');
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 编辑表格信息
			editTable(row, index) {
				this.appFormData = row
				this.isAdEditDialog = true
				this.dialogVisible = true
				this.$nextTick(()=>{
					// this.$refs.menuTreeRef.setCheckedKeys([]);
					// this.updateTreeStyles();
					this.configChecked = []
					if (this.appFormData.companyIds && this.appFormData.companyIds.length > 0) {
						this.configChecked = JSON.parse(JSON.stringify(this.appFormData.companyIds))
						this.configChecked.forEach((v) => {
							this.treeData.forEach((item,i) => {
								if(v === item.id){
									item.checked = true
								}
							})
						  // this.$refs.menuTreeRef.setChecked(v, true ,false);
						})
					}
					this.dimensionCheckAll = this.configChecked.length === this.treeData.length
					this.isDimensionIndeterminate = this.configChecked.length > 0 &&  this.configChecked.length < this.treeData.length
				})
			},
			// 表格弹窗关闭
			closeAPPDialog() {
				this.dialogVisible = false
			},
			// 账户管理确定
			confirmAPP(formName) {
				// console.log(this.appFormData.type);
				// let appIds = this.getMenuAllCheckedKeys();
				let companyIds = this.configChecked;
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(!this.appFormData.roleIds||this.appFormData.roleIds.length<=0){
							this.$message.warning('请选择角色');
							return
						}
						let data = this.appFormData;
						data['companyIds'] = companyIds
						let res = await this.$http.post(this.$api.adminUserEdit, data);
						if(res.code == 1){
							if(this.appFormData.id){
								this.$message.success('编辑成功');
							}else{
								this.$message.success('新增成功');
							}
						}
						this.closeAPPDialog();
						this.getTableData();
					}
				});
			},
			resetPwd(row,index){
				this.pwdFormData = row
				this.dialogVisiblePwd = true
			},
			closePwdDialog(){
				this.dialogVisiblePwd = false
			},
			// 重置密码确认
			confirmPwd(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.pwdFormData;
						let res = await this.$http.post(this.$api.resetPwd, data);
						if(res.code == 1){
							this.$message.success('重置成功');
						}
						this.closePwdDialog();
						this.getTableData();
					}
				});
			},
			// 用户位状态修改
			async userSwitchChange(e,row){
				let data = {
					id: row.id,
					status: e
				}
				let res = await this.$http.post(this.$api.userManage.userStatus, data);
				if(res.code == 1){
					this.$message.success('状态修改成功');
				}
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 22px; */
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}
	
	.tableTopBtn {
		margin-bottom: 16px;
		align-items: center;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}
	
	.el_tree {
		margin-top: 10px;
		/* background: #F1F1F4; */
		height: 450px;
		overflow-y: auto;
		border: 1px solid #E3E2E5;
		padding: 5px 15px;
		box-sizing: border-box;
		/* padding: 10px; */
	}
	.check-box-fixed{
		width: 44%;
	}
	
	.el_tree /deep/.el-tree {
		background: #F1F1F4;
		color: #333333;
		font-weight: 500;
		font-size: 12px;
	}
	
	.custom-tree-node {
		width: 100%;
		height: 100%;
		line-height: 44px;
	}
	
	.el_tree /deep/.el-tree-node__content {
		height: 44px;
	}
</style>